import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../components/shared/page-layout/page-layout.component';

declare global {
  interface Window {
    Calendly?: any;
  }
}

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent implements OnInit, OnDestroy {
  // Page layout configuration
  title = 'Contactez-nous !';
  subtitle = 'Par email, par téléphone, par tchat, via devis en ligne ou en fixant un RDV à l\'avance, nous sommes disponibles et très réactifs pour vous conseiller dans le choix de vos assurances.';
  heroImage = 'assets/static_pages_images/contact.jpeg';
  breadcrumbs = [{ label: 'Contact' }];
  prevPage = { title: 'Blog', link: '/blog' };
  nextPage = { title: 'Recrutement', link: '/recrutement' };

  ngOnInit(): void {
    this.loadCalendly();
  }

  ngOnDestroy(): void {
    // Nettoyer le badge widget quand on quitte la page
    this.destroyCalendlyBadge();
  }

  private loadCalendly(): void {
    const scriptId = 'calendly-widget-script';

    // Vérifier si le script existe déjà
    const existingScript = document.getElementById(scriptId);
    
    if (existingScript) {
      // Si le script existe, initialiser directement le badge
      setTimeout(() => this.initCalendlyBadge(), 100);
      return;
    }

    // Charger le script Calendly
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.onload = () => {
      // Attendre un peu que Calendly soit complètement chargé
      setTimeout(() => this.initCalendlyBadge(), 100);
    };

    document.body.appendChild(script);
  }

  private initCalendlyBadge(): void {
    if (window.Calendly) {
      // Initialiser le badge widget uniquement sur cette page
      window.Calendly.initBadgeWidget({
        url: 'https://calendly.com/lea-blanchard-brokins/30min?primary_color=a100ff',
        text: 'Planifier du temps avec moi',
        color: '#a100ff',
        textColor: '#ffffff',
        branding: false
      });
    }
  }

  private destroyCalendlyBadge(): void {
    try {
      // Supprimer le badge widget du DOM manuellement
      const badge = document.querySelector('.calendly-badge-widget');
      if (badge && badge.parentElement) {
        badge.parentElement.removeChild(badge);
      }

      // Alternative: essayer de fermer aussi le popup s'il est ouvert
      const popup = document.querySelector('.calendly-overlay');
      if (popup && popup.parentElement) {
        popup.parentElement.removeChild(popup);
      }
    } catch (error) {
      // Ignorer silencieusement les erreurs de nettoyage
      console.debug('Calendly cleanup warning:', error);
    }
  }

  openAppointmentPicker(): boolean {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/lea-blanchard-brokins/30min?primary_color=a100ff'
      });
    }
    return false; // Empêcher la navigation
  }
}
